//
//
//
//
//
//

export default {
  name: 'app'
  /* updated() {
    if (typeof WeixinJSBridge == 'undefined') {
      document.addEventListener(
        'WeixinJSBridgeReady',
        function () {
          WeixinJSBridge.call('hideOptionMenu')
        },
        false
      )
    } else {
      WeixinJSBridge.call('hideOptionMenu')
    }
  } */
}



// WEBPACK FOOTER //
// ./src/App.vue